var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E63956",
    fillOpacity: 0.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.392 11.5L29.918 28C30.0057 28.152 30.0519 28.3244 30.0519 28.5C30.052 28.6755 30.0057 28.8479 29.918 28.9999C29.8302 29.152 29.704 29.2782 29.552 29.366C29.4 29.4537 29.2275 29.5 29.052 29.5H9.99997C9.82444 29.5 9.652 29.4537 9.49998 29.366C9.34797 29.2782 9.22173 29.152 9.13397 28.9999C9.0462 28.8479 9 28.6755 9 28.5C9 28.3244 9.04621 28.152 9.13397 28L18.66 11.5C18.7477 11.3479 18.874 11.2217 19.026 11.134C19.178 11.0462 19.3504 11 19.526 11C19.7015 11 19.8739 11.0462 20.026 11.134C20.178 11.2217 20.3042 11.3479 20.392 11.5ZM18.526 24.5V26.5H20.526V24.5H18.526ZM18.526 17.5V22.5H20.526V17.5H18.526Z",
    fill: "#E63956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.b285965136cee2f95ce32e3f1a21d3c8.svg";
export { ForwardRef as ReactComponent };